import React from 'react';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

import strings from '../../constant/strings';
import { TopBar } from './styles';

/**
 * The heading bar on the pre-order sign-in and verification screens.
 *
 * This traffic arrives cold from a social post, often on a phone, and these
 * two screens ask for an email address in the middle of a reservation - so
 * each one opens by saying what it is part of, and that nothing is being
 * charged today.
 *
 * The product page does not show it. There the product, its price, the
 * "nothing to pay today" line and the step indicator all say as much
 * already, and the band was one more thing to scroll past before any of
 * them. It carries no action either: reserving asks for an account at the
 * point it is needed, and the site header above still carries Login.
 *
 * It is a banner, not the page heading. Each screen's h1 is its own
 * question, so the text here carries no heading semantics and cannot
 * disturb their order.
 */
const PreorderTopBar = () => (
  <TopBar aria-label={strings.preorder}>
    <div className="lead">
      <span className="badge" aria-hidden>
        <LocalShippingOutlinedIcon sx={{ fontSize: 22 }} />
      </span>
      <div>
        <div className="title">{strings.preorder}</div>
        <div className="subtitle">{strings.paymentCollectedBefore}</div>
      </div>
    </div>
  </TopBar>
);

export default PreorderTopBar;
